import React, { useEffect } from 'react'
import { checkUserSubscription } from '../http/http';
import { useDispatch, useSelector } from 'react-redux';
import { removeUserToken } from '../store/slices/userTokenSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const Auth = ({ children }) => {
    const { userToken } = useSelector(state => state.persisted.userTokenSlice);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location=useLocation();
    const { t } = useTranslation();

    const checkSubscription = async () => {
        try {
            const response = await checkUserSubscription(userToken);

        } catch (error) {
            if (error?.response?.data?.error?.status == 0) {
                // subscription has expired now...
                dispatch(removeUserToken());
                toast.error(t("111"));
                navigate("/");

            }
            else if (error?.response?.data?.error?.status == 1) {
                //  subscription has expired now..
                dispatch(removeUserToken());
                toast.error(t("111"));
                navigate("/");

            }
        }
    }

    useEffect(() => {
        if (userToken) {
            checkSubscription();
        }
        else {
            navigate("/");
        }
    }, [userToken,location]);
    return (
        <>{children}</>
    )
}

export default Auth